import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// Components
import Home from '../components/Home'
import materia from '../components/materia'
import privacidade from '../components/politica_privacidade'
import curso from '../components/curso'
import cursos from '../components/widgets/cursos'
import autor from '../components/autor'
import search from '../components/search'
import Erro404 from '../components/Erro404'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },    
    {
      path: '/cursos/:area/:slug',
      name: 'curso',
      component: curso,
    },
    {
      path: '/eventos-noticias/:slug',
      name: 'materia',
      component: materia,
    },
    {
      path: '/autor/:name',
      name: 'autor',
      component: autor,
    },
    {
      path: '/pesquisar',
      name: 'pesquisar',
      component: search,
    },
    {
      path: '/:page/autor/:autor',
      name: 'blog',
      component: Home,
    },
    {
      path: '/blog/:slug',
      name: 'post',
      component: materia,
    },
    {
      path: '/politica-de-privacidade',
      name: 'politica-privacidade',
      component: privacidade,
    },
    {
      path: '/:page',
      name: 'page',
      component: Home,
      beforeEnter: (to, from, next) => {
        function isValid (param) {
          var arrPages = [
            'bauhaus',
            'eventos',
            'videos',
            'fale-conosco',
            'unifran',
            'concurso-de-bolsas',
            'autores',
            'blog',
            'ebooks',
            'cursos',
            'politica-de-privacidade',
          ]
          if (arrPages.indexOf(param) >= 0) {
            return true
          }
          return false
        }
     
        if (!isValid(to.params.page)) {
          next({name: 'not-found', params: [to.path], replace: true});
        }
     
        next();
      }
    },
    {
      path: '/:page/:area',
      name: 'page',
      component: Home,
    },
    {
      path: '/:page/play/:titulo/:id',
      name: 'page',
      component: Home,
    },
    {
      path: '/:page/play/:titulo/:id',
      name: 'page',
      component: Home,
    },
    {
      path: '/:page/categoria/:categoria',
      name: 'blog-item',
      component: Home,
    },
    {
      path: '*',
      name: 'not-found',
      component: Erro404,
    },
  ],

  mode: 'history',
  base: '',

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (store.state.page.all) {
    var pages = store.state.page.all
    var path  = to.path.substr(1)
    var index = pages.findIndex((o) => o.slug == path);

    if (to.path == '/') {
      index = pages.findIndex((o) => o.slug == 'index');
    } else if (to.path.indexOf('/cursos/') >= 0) {
      index = pages.findIndex((o) => o.slug == 'cursos');
    } else if (to.path.indexOf('/blog/autor/')  >= 0) {
      index = pages.findIndex((o) => o.slug == 'autores');
    }
    
    if (index >= 0) {
      var page = pages[index]
      var arrTitle = document.title.split('|');
      var [baseTitle] = arrTitle.slice(-1);

      var d = document.createElement('div');
      d.innerHTML = `${page.title.rendered} | ${baseTitle}`
      
      document.title = d.innerText
    }
  }
  // Voltar quando for pro Live
  // if(to.path == '/concurso-de-bolsas'){
  //   var month = moment().month()

  //   if(month != 0 && month != 6){
  //     next('/')
  //     return
  //   }
  // }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js